import Image from 'components/gruenland/atoms/image';
import { EditorialContentConfiguration } from 'components/gruenland/organisms/product-list/types';

type Props = EditorialContentConfiguration;

const EditorialTile: React.FC<Props> = ({ image }) => {
  return (
    <div className="relative bg-primary-green">
      <Image media={image.media} fill className="object-cover" />
    </div>
  );
};

export default EditorialTile;
